import { FeatureBase } from "./base/FeatureBase";

export class CompanySearcher extends FeatureBase {

  private setFormData: any;
  private formData = {};

  public delayAdresZoeker = null;
  public fieldNames: string[] = [
    "Naam",
    "Plaats",
    "Straat",
    "Huisnummer",
    "Toevoeging",
    "Postcode",
    "BedrijfsadresgegevensAutomatisch",
    "BedrijfsadresgegevensManueel"
  ]

  constructor(formData: any = null, setFormData: any = null) {
    super();
    this.formData = formData;
    this.setFormData = setFormData;
  }

  public initFeatureField(field: Field, formDataEntry: FormDataEntry, fields: Field[]): FormDataEntry {
    const fieldName = field["@column"];
    const prefix = this.getPrefixFromFieldName(fieldName);

    formDataEntry.enabled = (this.fieldNames.find((name) => `${prefix}${name}` == fieldName) && (fieldName !== `${prefix}Plaats`)) ? false : true;
    if(fieldName.endsWith("BedrijfsadresgegevensAutomatisch")) {
      formDataEntry.enabled = true;
    }
    if(fieldName.endsWith("BedrijfsadresgegevensManueel")) {
      formDataEntry.enabled = false;
    }
    return formDataEntry;
  }

  public handleCompanyCityChange = (e) => {
    const { name, value } = e.target;
    const prefix = this.getPrefixFromFieldName(name);

    this.setFormData((prevFormData) => {
      if(prevFormData[`${prefix}Plaats`]?.value == value) {
        return prevFormData;
      }

      const newFormData = {
        ...prevFormData,
        [`${prefix}Guid`]: { value: null, focus: false, touched: false, enabled: false } as FormDataEntry,
        [`${prefix}Plaats`]: { value: value, focus: true, touched: true, enabled: true } as FormDataEntry,
        [`${prefix}Naam`]: { value: "", focus: false, touched: false, enabled: true } as FormDataEntry,
        [`${prefix}Straat`]: { value: "", focus: false, touched: false, enabled: false } as FormDataEntry,
        [`${prefix}Huisnummer`]: { value: "", focus: false, touched: false, enabled: false } as FormDataEntry,
        [`${prefix}Toevoeging`]: { value: "", focus: false, touched: false, enabled: false } as FormDataEntry,
        [`${prefix}Postcode`]: { value: "", focus: false, touched: false, enabled: false } as FormDataEntry,
        [`${prefix}BedrijfsadresgegevensAutomatisch`]: { enabled: true },
        [`${prefix}BedrijfsadresgegevensManueel`]: { enabled: false },
      };
      
      return newFormData;
    });
  }

  public handleCompanySearchChange = (companyDetails: CompanyDetailsType | null) => {
    const prefix = this.getPrefixFromFieldName(companyDetails.fieldName);
    const isnew = companyDetails?.isNew ?? true;
    const isSameNewCompany = isnew && this.formData[`${prefix}Guid`].value == "";
    
    this.setFormData((prevFormData) => {
      const { Bedrijfsnaam, BedrijfsGuid, Straat, PostalCode, AddressLine1, AddressLine2 } = companyDetails

      const newFormData = {
        ...prevFormData,
        [`${prefix}Naam`]: { value: Bedrijfsnaam, focus: false, touched: false, enabled: isnew } as FormDataEntry,
        [`${prefix}Guid`]: isSameNewCompany ? this.formData[`${prefix}Guid`] : { value: isnew ? "" : BedrijfsGuid, focus: false, touched: false, enabled: false } as FormDataEntry,
        [`${prefix}Straat`]: isSameNewCompany ? this.formData[`${prefix}Straat`] : { value: isnew ? "" : Straat, focus: false, touched: false, enabled: isnew } as FormDataEntry,
        [`${prefix}Huisnummer`]: isSameNewCompany ? this.formData[`${prefix}Huisnummer`] : { value: isnew ? "" : AddressLine1, focus: false, touched: false, enabled: isnew } as FormDataEntry,
        [`${prefix}Toevoeging`]: isSameNewCompany ? this.formData[`${prefix}Toevoeging`] : { value: isnew ? "" : AddressLine2, focus: false, touched: false, enabled: isnew } as FormDataEntry,
        [`${prefix}Postcode`]: isSameNewCompany ? this.formData[`${prefix}Postcode`] : { value: isnew ? "" : PostalCode?.replace(/\s/g, ""), focus: false, touched: false, enabled: isnew } as FormDataEntry,
        [`${prefix}BedrijfsadresgegevensAutomatisch`]: { enabled: !isnew },
        [`${prefix}BedrijfsadresgegevensManueel`]: { enabled: isnew },
      };
      
      return newFormData;
    });
  }
}